export const DROPDOWN_PLACEHOLDER_WIDTH = 28;

export const defaultHideOrder: Array<string> = [];
